/* Ott-common */
import { ClientType } from '@dtvgo/backend-service/normalize';
import { Platform as AemPlatform } from '@dtvgo/aem-service';

/* Utils */
// import queryString from 'query-string';
import {
  isVegaOS,
  getDeviceInfo,
  changeBackButtonActions,
  closeApp,
} from './general';
import {
  Platform,
  MsToWaitOnReconnection,
  DrmKeySystem,
} from '../../constants';
// import importScript from '../../importScript';

import {
  PLAY_PAUSE,
  REWIND,
  FAST_FORWARD,
  BACK,
} from './keyCodes';

// const CORDOVA_BASE_URL_KEY = 'cordovaBaseUrl';

function init() {
  changeBackButtonActions();
  // const splittedBaseUrl = queryString.parse(window.location?.search)?.baseUrl?.split('/');
  // let baseUrl = splittedBaseUrl?.slice(0, -1).join('/');

  // if (!baseUrl) baseUrl = localStorage.getItem(CORDOVA_BASE_URL_KEY, baseUrl);

  // localStorage.setItem(CORDOVA_BASE_URL_KEY, baseUrl);
  // importScript(`${baseUrl}/cordova.js`);
}

export default {
  osName: 'VegaOS',
  appName: 'vega_os',
  aemPlatform: AemPlatform.WEBOS,
  clientType: ClientType.FIRE,
  isThisPlatform: isVegaOS,
  init,
  // App and device info
  getDeviceInfo,
  // Functions
  closeApp,
  sendAppToBackground: closeApp,
  msToWaitOnReconnection: MsToWaitOnReconnection[Platform.VEGAOS],
  // Player related options
  isPlayreadyUtf8AndPlain: true,
  // DRM Preference
  drmKeySystem: DrmKeySystem.WIDEVINE,
  // NPAW
  npaw: {
    name: 'VEGAOS',
  },
  // Key codes
  keyCodes: {
    back: BACK,
    mediaControl: {
      playPause: PLAY_PAUSE,
      rewind: REWIND,
      fastForward: FAST_FORWARD,
    },
  },
};
